import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      table_number: 'getPosSelectedTableNumber', // selected table_number
      customer_id: 'getPosSelectedCustomerId', // selected customer_id
      getCustomerById: 'getCustomerById',
      getTableById: 'getPosTableById', // table info
    }),
    customerInfo () {
      return this.getCustomerById(this.customer_id)
    },
    tableInfo () {
      return this.getTableById(this.table_number)
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
    ]),
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/customerButton.js